import React from 'react';
import { motion } from 'framer-motion';
const areas = [{
  title: 'The Main Dining Room',
  description: 'Dimly lit and impeccably designed, offering an intimate setting for unforgettable evenings.'
}, {
  title: 'The Cocktail Lounge',
  description: 'A sophisticated space to unwind with expertly crafted libations and premium spirits.'
}, {
  title: 'Private Dining',
  description: 'Exclusive spaces tailored for celebrations, corporate gatherings, and special occasions.'
}];
export function Atmosphere() {
  return <section id="atmosphere" className="py-32 px-6 bg-brand-black" data-id="element-16">
      <div className="max-w-7xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-18">
          <h2 className="font-serif text-4xl md:text-5xl text-brand-offwhite mb-6" data-id="element-19">
            The Atmosphere
          </h2>
          <div className="w-12 h-px bg-brand-gold mx-auto mb-6" data-id="element-20"></div>
          <p className="text-brand-offwhite/60 max-w-2xl mx-auto" data-id="element-21">
            Experience an environment where every detail has been curated for
            your comfort and delight.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-22">
          {areas.map((area, idx) => <motion.div key={area.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: idx * 0.2
        }} className="group cursor-pointer" data-id="element-23">
              {/* Placeholder Image Area */}
              <div className="aspect-[4/5] w-full bg-brand-charcoal border border-brand-gold/10 relative overflow-hidden mb-6 flex items-center justify-center group-hover:border-brand-gold/40 transition-colors duration-500" data-id="element-24">
                {/* Subtle pattern instead of an image */}
                <div className="absolute inset-0 bg-[length:16px_16px] bg-subtle-pattern opacity-10 group-hover:opacity-20 transition-opacity duration-500" data-id="element-25"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-brand-black/80 to-transparent" data-id="element-26"></div>

                {/* Decorative element in center */}
                <div className="w-16 h-16 border border-brand-gold/20 rotate-45 group-hover:rotate-90 transition-transform duration-700 ease-in-out flex items-center justify-center" data-id="element-27">
                  <div className="w-8 h-8 border border-brand-gold/20" data-id="element-28"></div>
                </div>
              </div>

              <h3 className="font-serif text-2xl text-brand-gold mb-3 text-center" data-id="element-29">
                {area.title}
              </h3>
              <p className="text-brand-offwhite/60 text-center text-sm leading-relaxed px-4" data-id="element-30">
                {area.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}